// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"760":"1604b2b6","874":"3a51ee2a"}[chunkId] + ".chunk.js";
};